import * as Constants from './constants'
const initialState = {
  list: [],
  item: {},
  type: Constants.NHAPKHO_LIST_INITING,
  listRequesting: false,
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
}

const reducer = function nhapkhoReducer (state = initialState, action) {
  switch (action.type) {

    case Constants.NHAPKHO_LIST_NCC_REQUESTING:
    return {
      list: [],
      item: {},
      type: action.type,
      listRequesting: true,
      requesting: false,
      successful: false,
      messages: [{
        body: 'Fetching data...!',
        time: new Date(),
      }],
      errors: [],
    }

  case Constants.NHAPKHO_LIST_NCC_SUCCESS:
    return {
      ...state, // ensure that we don't erase fetched ones
      type: action.type,
      listNcc: action.data.records,
      item: action.data,
      listRequesting: false,
      requesting: false,
      successful: true,
      messages: [],
      errors: [],
    }

  case Constants.NHAPKHO_LIST_NCC_ERROR:
    return {
      ...state, // ensure that we don't erase fetched ones
      type: action.type,
      list: [],
      item: {},
      listRequesting: false,
      requesting: false,
      successful: false,
      messages: [],
      errors: [{
        body: action.error.toString(),
        time: new Date(),
      }],
    }

    case Constants.NHAPKHO_LIST_KHO_REQUESTING:
    return {
      list: [],
      item: {},
      type: action.type,
      listRequesting: true,
      requesting: false,
      successful: false,
      messages: [{
        body: 'Fetching data...!',
        time: new Date(),
      }],
      errors: [],
    }

  case Constants.NHAPKHO_LIST_KHO_SUCCESS:
    return {
      ...state, // ensure that we don't erase fetched ones
      type: action.type,
      listKho: action.data.records,
      item: action.data,
      listRequesting: false,
      requesting: false,
      successful: true,
      messages: [],
      errors: [],
    }

  case Constants.NHAPKHO_LIST_KHO_ERROR:
    return {
      ...state, // ensure that we don't erase fetched ones
      type: action.type,
      list: [],
      item: {},
      listRequesting: false,
      requesting: false,
      successful: false,
      messages: [],
      errors: [{
        body: action.error.toString(),
        time: new Date(),
      }],
    }

    case Constants.NHAPKHO_LIST_PRODUCT_REQUESTING:
    return {
      list: [],
      item: {},
      type: action.type,
      requesting: true,
      successful: false,
      messages: [{
        body: 'Fetching data...!',
        time: new Date(),
      }],
      errors: [],
    }

    case Constants.NHAPKHO_LIST_PRODUCT_SUCCESS:
    return {
      ...state, // ensure that we don't erase fetched ones
      type: action.type,
      list: action.data.records,
      item: {},
      requesting: false,
      successful: true,
      messages: [],
      errors: [],
    }

  case Constants.NHAPKHO_LIST_PRODUCT_ERROR:
    return {
      ...state, // ensure that we don't erase fetched ones
      type: action.type,
      list: [],
      item: {},
      requesting: false,
      successful: false,
      messages: [],
      errors: [{
        body: action.error.toString(),
        time: new Date(),
      }],
    }

    case Constants.NHAPKHO_SAVE_REQUESTING:
    return {
      ...state, // ensure that we don't erase fetched ones
      list: [],
      item: {},
      type: action.type,
      requesting: true,
      successful: false,
      messages: [{
        body: 'Fetching data...!',
        time: new Date(),
      }],
      errors: [],
    }

  case Constants.NHAPKHO_SAVE_SUCCESS:
    return {
      ...state, // ensure that we don't erase fetched ones
      list: [],
      item: action.data,
      type: action.type,
      requesting: false,
      successful: true,
      messages: [{
        body: 'Nhập thuốc thành công',
        time: new Date(),
      }],
      errors: [],
    }

  case Constants.NHAPKHO_SAVE_ERROR:
    return {
      ...state, // ensure that we don't erase fetched ones
      list: [],
      item: {},
      type: action.type,
      requesting: false,
      successful: false,
      messages: [],
      errors: [{
        body: action.error.toString(),
        time: new Date(),
      }],
    }

    case Constants.NHAPKHO_DETAIL_REQUESTING:
    return {
      ...state, // ensure that we don't erase fetched ones
      list: [],
      item: {},
      type: action.type,
      requesting: true,
      successful: false,
      messages: [{
        body: 'Fetching data...!',
        time: new Date(),
      }],
      errors: [],
    }

  case Constants.NHAPKHO_DETAIL_SUCCESS:
    return {
      ...state, // ensure that we don't erase fetched ones
      list: [],
      item: action.data,
      type: action.type,
      requesting: false,
      successful: true,
      messages: [],
      errors: [],
    }

  case Constants.NHAPKHO_DETAIL_ERROR:
    return {
      ...state, // ensure that we don't erase fetched ones
      list: [],
      item: {},
      type: action.type,
      requesting: false,
      successful: false,
      messages: [],
      errors: [{
        body: action.error.toString(),
        time: new Date(),
      }],
    }
    case Constants.NHAPKHO_UPDATE_REQUESTING:
    return {
      ...state, // ensure that we don't erase fetched ones
      list: [],
      item: {},
      type: action.type,
      requesting: true,
      successful: false,
      messages: [{
        body: 'Fetching data...!',
        time: new Date(),
      }],
      errors: [],
    }

  case Constants.NHAPKHO_UPDATE_SUCCESS:
    return {
      ...state, // ensure that we don't erase fetched ones
      list: [],
      item:  action.data,
      type: action.type,
      requesting: false,
      successful: true,
      messages: [{
        body: 'Đơn thuốc lưu thành công',
        time: new Date(),
      }],
      errors: [],
    }

  case Constants.NHAPKHO_UPDATE_ERROR:
    return {
      ...state, // ensure that we don't erase fetched ones
      list: [],
      item: {},
      type: action.type,
      requesting: false,
      successful: false,
      messages: [],
      errors: [{
        body: action.error.toString(),
        time: new Date(),
      }],
    }
    case Constants.NHAPKHO_PRODUCTS_LIST_DVT_REQUESTING:
    return {
      list: [],
      item: {},
      type: action.type,
      listRequesting: true,
      requesting: false,
      successful: false,
      messages: [{
        body: 'Đang gửi dữ liệu, vui lòng chờ trong giây lát...!',
        time: new Date(),
      }],
      errors: [],
    }

  case Constants.NHAPKHO_PRODUCTS_LIST_DVT_SUCCESS:
    return {
      ...state, // ensure that we don't erase fetched ones
      type: action.type,
      list: action.data.records,
      item: action.data,
      listRequesting: false,
      requesting: false,
      successful: true,
      messages: [],
      errors: [],
    }

  case Constants.NHAPKHO_PRODUCTS_LIST_DVT_ERROR:
    return {
      ...state, // ensure that we don't erase fetched ones
      type: action.type,
      list: [],
      item: {},
      listRequesting: false,
      requesting: false,
      successful: false,
      messages: [],
      errors: [{
        body: action.error.toString(),
        time: new Date(),
      }],
    }
    case Constants.NHAPKHO_DUYET_REQUESTING:
    return {
      ...state, // ensure that we don't erase fetched ones
      list: [],
      item: {},
      type: action.type,
      requesting: true,
      successful: false,
      messages: [{
        body: 'Fetching data...!',
        time: new Date(),
      }],
      errors: [],
    }

  case Constants.NHAPKHO_DUYET_SUCCESS:
    return {
      ...state, // ensure that we don't erase fetched ones
      list: [],
      item: action.data,
      type: action.type,
      requesting: false,
      successful: true,
      messages: [{
        body: 'Duyệt nhập thuốc thành công',
        time: new Date(),
      }],
      errors: [],
    }

  case Constants.NHAPKHO_DUYET_ERROR:
    return {
      ...state, // ensure that we don't erase fetched ones
      list: [],
      item: {},
      type: action.type,
      requesting: false,
      successful: false,
      messages: [],
      errors: [{
        body: action.error.toString(),
        time: new Date(),
      }],
    }
  case Constants.NHAPKHO_HUY_DUYET_REQUESTING:
    return {
      ...state, // ensure that we don't erase fetched ones
      list: [],
      item: {},
      type: action.type,
      requesting: true,
      successful: false,
      messages: [{
        body: 'Fetching data...!',
        time: new Date(),
      }],
      errors: [],
    }

  case Constants.NHAPKHO_HUY_DUYET_SUCCESS:
    return {
      ...state, // ensure that we don't erase fetched ones
      list: [],
      item: action.data,
      type: action.type,
      requesting: false,
      successful: true,
      messages: [{
        body: 'Huỷ nhập thuốc thành công',
        time: new Date(),
      }],
      errors: [],
    }

  case Constants.NHAPKHO_HUY_DUYET_ERROR:
    return {
      ...state, // ensure that we don't erase fetched ones
      list: [],
      item: {},
      type: action.type,
      requesting: false,
      successful: false,
      messages: [],
      errors: [{
        body: action.error.toString(),
        time: new Date(),
      }],
    }

  case Constants.NHAPKHO_GEN_BARCODE_REQUESTING:
    return {
      list: [],
      item: {},
      type: action.type,
      requesting: true,
      successful: false,
      messages: [{
        body: 'Fetching data...!',
        time: new Date(),
      }],
      errors: [],
    }

  case Constants.NHAPKHO_GEN_BARCODE_SUCCESS:
    return {
      ...state, // ensure that we don't erase fetched ones
      type: action.type,
      list: [],
      item: action.data,
      requesting: false,
      successful: true,
      messages: [],
      errors: [],
    }

  case Constants.NHAPKHO_GEN_BARCODE_ERROR:
    return {
      ...state, // ensure that we don't erase fetched ones
      type: action.type,
      list: [],
      item: {},
      requesting: false,
      successful: false,
      messages: [],
      errors: [{
        body: action.error.toString(),
        time: new Date(),
      }],
    }

    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/NhapKho/reducer.js